import GlobalContexts from './GlobalContexts.js';
import Gateway from './Gateway.js';
import SenderLock from './events/async/SenderLock';
import PendingEvents from './events/async/PendingEvents';

export default class Snowplow {
  constructor(config) {
    if(Gateway.isAutoV10)
    {
      SenderLock.lockSending();
    }
    this.pendingEvents = new PendingEvents();
    this.config = config;
    this.globalContexts = new GlobalContexts();
    if (!this._isLoaded()) {
      this._appendScript(Gateway.window, Gateway.window.document, 'script', config.src, config.namespace);
      this._createTrackers(config.trackers, Gateway.window.location.hostname);
    }
    this._defineEventTrackers(config.trackers);
  }

  callSnowplow() {
    return Gateway.window[this.config.namespace].apply(undefined, arguments);
  }

  addTracker(name, endPoint, settings) {
    this.callSnowplow('newTracker', name, endPoint, settings);
  }

  setCustomUrl(url) {
    this.callSnowplow('setCustomUrl', url);
  }

  setUserId(id) {
    this.callSnowplow('setUserId', id);
  }

  _appendScript(p, l, o, w, i, n, g) {
    p.GlobalSnowplowNamespace = p.GlobalSnowplowNamespace || [];
    p.GlobalSnowplowNamespace.push(i);
    p[i] = function () {
      (p[i].q = p[i].q || []).push(arguments);
    };
    p[i].q = p[i].q || [];
    n = l.createElement(o);
    g = l.getElementsByTagName(o)[0];
    n.async = 1;
    n.src = w;
    g.parentNode.insertBefore(n, g);
  }

  _isLoaded() {
    return typeof Gateway.window[this.config.namespace] === 'function';
  }

  _createTrackers(trackers, appId) {
    trackers.forEach(tracker => this.addTracker(tracker.name, tracker.endPoint, { appId, ...tracker.settings }));
  }

  _defineEventTrackers(trackers) {
    this._eventTrackers = Gateway.isAutoV10 ? 'nd' : trackers.map(tracker => tracker.name).join(';');
  }

  prepareEventName(event) {
    return event + ':' + this._eventTrackers;
  }
}
